import { useFeatureFlag } from '@hooks/useFeatureFlag';
import React from 'react';
import { OfferCard } from './OfferCard/OfferCard';
import { OfferCard as NewOfferCard } from './NewOfferCard/OfferCard';

const OfferCardSelector = ({ description, paymentOptions = [], testingCategoryTitle, hideHeader }) => {
  const { data: financeFeatureFlag } = useFeatureFlag('financing-offer');
  if (financeFeatureFlag?.isActive) {
    return (
      <NewOfferCard
        paymentOptions={paymentOptions}
        description={description}
        testingCategoryTitle={testingCategoryTitle}
      />
    );
  } else {
    return (
      <OfferCard
        description={description}
        paymentOptions={paymentOptions}
        testingCategoryTitle={testingCategoryTitle}
        hideHeader={hideHeader}
      />
    );
  }
};

export default OfferCardSelector;
